(function () {
  if (window.initKlaviyoDelayedForm) return;
  window._umKlaviyoInitQueue = window._umKlaviyoInitQueue || [];
  window.dataLayer = window.dataLayer || [];

  /*
   * HOLDOUT EXPERIMENT DISABLED.
   * Kept commented out so the previous assignment, attribution, GA4 and cart
   * instrumentation can be restored if the experiment is needed again.
   * Desktop popup suppression now happens in initKlaviyoDelayedForm below.
   *
  var EXPERIMENT_NAME = 'popup_fd_2026_hiintent_desktop_v1';
  var EXPERIMENT_SPLIT = 0.5;
  var EXPERIMENT_DAYS = 60;
  var EXPERIMENT_CONTEXT_KEY = 'popup_experiment_context_' + EXPERIMENT_NAME;
  var CART_ATTRIBUTE_KEY = 'popup_fd_2026_hiintent_desktop_v1';
  var SEARCH_ENGINE_HOSTS = [
    'google.',
    'bing.com',
    'search.yahoo.com',
    'duckduckgo.com',
    'ecosia.org',
    'yandex.',
    'baidu.com',
    'aol.com',
    'ask.com',
    'naver.com',
    'seznam.cz'
  ];
  var SEARCH_UTM_SOURCES = {
    google: true,
    bing: true,
    yahoo: true,
    duckduckgo: true,
    ecosia: true,
    yandex: true,
    baidu: true,
    aol: true,
    ask: true
  };
  var GOOGLE_PAID_MEDIUMS = {
    cpc: true,
    ppc: true,
    sem: true,
    paidsearch: true,
    'paid-search': true,
    display: true,
    shopping: true
  };
  var EMAIL_MEDIUMS = {
    email: true,
    'e-mail': true,
    newsletter: true,
    edm: true
  };
  var EMAIL_SOURCES = {
    email: true,
    klaviyo: true,
    mailchimp: true
  };
  var SOCIAL_UTM_SOURCES = {
    facebook: true,
    instagram: true,
    meta: true,
    fb: true,
    ig: true,
    tiktok: true,
    twitter: true,
    x: true,
    pinterest: true,
    snapchat: true,
    linkedin: true,
    reddit: true
  };
  var SOCIAL_REFERRER_HOSTS = [
    'facebook.com',
    'instagram.com',
    'tiktok.com',
    'twitter.com',
    'x.com',
    'pinterest.com',
    'snapchat.com',
    'linkedin.com',
    'lnkd.in',
    'reddit.com'
  ];
  var SOCIAL_CLICK_IDS = [
    'fbclid',
    'ttclid',
    'twclid',
    'li_fat_id',
    'epik'
  ];
  var OTHER_PAID_CLICK_IDS = [
    'msclkid'
  ];

  function now() {
    return Date.now();
  }

  function setCookie(name, value, days) {
    var expires = new Date(now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var prefix = name + '=';
    var row = document.cookie
      .split('; ')
      .find(function (cookieRow) {
        return cookieRow.indexOf(prefix) === 0;
      });
    if (!row) return '';
    return row.substring(prefix.length);
  }

  function readJson(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writeContext(context) {
    var serialized = JSON.stringify(context);
    try {
      localStorage.setItem(EXPERIMENT_CONTEXT_KEY, serialized);
    } catch (e) {
      // localStorage may be blocked
    }
    try {
      setCookie(EXPERIMENT_CONTEXT_KEY, serialized, EXPERIMENT_DAYS);
    } catch (e) {
      // cookie write may fail
    }
  }

  function clearContext() {
    try {
      localStorage.removeItem(EXPERIMENT_CONTEXT_KEY);
    } catch (e) {
      // ignore
    }
    try {
      document.cookie = EXPERIMENT_CONTEXT_KEY + '=; Max-Age=0; path=/; SameSite=Lax';
    } catch (e) {
      // ignore
    }
  }

  function readStoredContext() {
    var localRaw = '';
    try {
      localRaw = localStorage.getItem(EXPERIMENT_CONTEXT_KEY) || '';
    } catch (e) {
      localRaw = '';
    }
    var context = readJson(localRaw);

    if (!context) {
      var cookieRaw = '';
      try {
        cookieRaw = decodeURIComponent(getCookie(EXPERIMENT_CONTEXT_KEY) || '');
      } catch (e) {
        cookieRaw = '';
      }
      context = readJson(cookieRaw);
    }
    if (!context) return null;

    if (context.name !== EXPERIMENT_NAME) {
      clearContext();
      return null;
    }

    if (!Number.isFinite(context.expiresAt) || context.expiresAt <= now()) {
      clearContext();
      return null;
    }

    return context;
  }

  function getReferrerHost() {
    try {
      return document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
    } catch (e) {
      return '';
    }
  }

  function isDesktopViewport() {
    if (!window.matchMedia) return true;
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function hasAnyUtm(params) {
    return !!(
      params.get('utm_source') ||
      params.get('utm_medium') ||
      params.get('utm_campaign')
    );
  }

  function hasAnyQueryParam(params, keys) {
    return keys.some(function (key) {
      return params.has(key);
    });
  }

  function hostIncludesAny(host, domainFragments) {
    if (!host) return false;
    return domainFragments.some(function (fragment) {
      return host.indexOf(fragment) !== -1;
    });
  }

  function classifyLandingTraffic() {
    var params = new URLSearchParams(window.location.search || '');
    var utmSource = (params.get('utm_source') || '').trim().toLowerCase();
    var utmMedium = (params.get('utm_medium') || '').trim().toLowerCase();
    var utmCampaign = (params.get('utm_campaign') || '').trim().toLowerCase();
    var hasGoogleClickId = params.has('gclid') || params.has('gbraid') || params.has('wbraid');
    var hasSocialClickId = hasAnyQueryParam(params, SOCIAL_CLICK_IDS);
    var hasOtherPaidClickId = hasAnyQueryParam(params, OTHER_PAID_CLICK_IDS);
    var referrerHost = getReferrerHost();
    var isSearchReferrer = !!referrerHost && SEARCH_ENGINE_HOSTS.some(function (domain) {
      return referrerHost.indexOf(domain) !== -1;
    });
    var isSearchOrganicUtm = !!SEARCH_UTM_SOURCES[utmSource] && (utmMedium === 'organic' || utmMedium === 'seo' || utmMedium === 'search');
    var hasPaidGoogleUtm = utmSource === 'google' && !!GOOGLE_PAID_MEDIUMS[utmMedium];
    var isEmailTraffic = !!EMAIL_MEDIUMS[utmMedium] || !!EMAIL_SOURCES[utmSource] || /newsletter|email/.test(utmCampaign);
    var isSocialTraffic = !!SOCIAL_UTM_SOURCES[utmSource] || hasSocialClickId || hostIncludesAny(referrerHost, SOCIAL_REFERRER_HOSTS);
    var isDirect = !referrerHost && !hasAnyUtm(params) && !hasGoogleClickId && !hasSocialClickId && !hasOtherPaidClickId;
    var isDesktop = isDesktopViewport();

    if (!isDesktop) {
      if (isDirect) {
        return {
          eligible: true,
          detectedChannel: 'direct',
          segment: 'mobile_direct',
          reason: ''
        };
      }
      return {
        eligible: false,
        detectedChannel: isSocialTraffic ? 'social' : (utmSource || (referrerHost ? 'non_target_referrer' : 'mobile')),
        reason: 'mobile_non_direct'
      };
    }

    if (isSocialTraffic) {
      return {
        eligible: false,
        detectedChannel: 'social',
        reason: 'desktop_non_target_channel'
      };
    }

    if (hasGoogleClickId || hasPaidGoogleUtm) {
      return {
        eligible: true,
        detectedChannel: 'google_ads',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    if (isEmailTraffic) {
      return {
        eligible: true,
        detectedChannel: 'email',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    if (isDirect) {
      return {
        eligible: true,
        detectedChannel: 'direct',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    if ((isSearchReferrer || isSearchOrganicUtm) && !hasGoogleClickId && !hasOtherPaidClickId && !hasPaidGoogleUtm && !isEmailTraffic) {
      return {
        eligible: true,
        detectedChannel: 'organic',
        segment: 'desktop_high_intent',
        reason: ''
      };
    }

    var reason = 'desktop_non_target_channel';
    if (!referrerHost && !utmSource && !utmMedium && utmCampaign) {
      reason = 'unknown_channel';
    }

    return {
      eligible: false,
      detectedChannel: referrerHost ? 'non_target_referrer' : (utmSource || 'unknown'),
      reason: reason
    };
  }

  function createExperimentContext(classification) {
    var source = classification || classifyLandingTraffic();
    var context = {
      name: EXPERIMENT_NAME,
      createdAt: now(),
      expiresAt: now() + (EXPERIMENT_DAYS * 864e5),
      eligible: source.eligible === true,
      detectedChannel: source.detectedChannel || 'unknown',
      segment: source.segment || '',
      reason: source.reason || '',
      variant: null
    };

    if (context.eligible) {
      context.variant = Math.random() < EXPERIMENT_SPLIT ? 'holdout' : 'show';
    }

    return context;
  }

  function getExperimentContext() {
    var stored = readStoredContext();
    if (stored) return stored;

    // Only persist when the visitor qualifies for this experiment cohort.
    // Non-eligible traffic is evaluated per landing so users can still enter
    // the test later from a qualifying desktop high-intent arrival.
    var classification = classifyLandingTraffic();
    var created = createExperimentContext(classification);
    if (created.eligible) {
      writeContext(created);
    }
    return created;
  }

  var experimentContext = getExperimentContext();
  if (experimentContext.eligible) {
    window.popupExperiment = {
      name: experimentContext.name,
      variant: experimentContext.variant,
      channel: experimentContext.detectedChannel,
      segment: experimentContext.segment || '',
      eligible: true
    };
  } else {
    try {
      delete window.popupExperiment;
    } catch (e) {
      window.popupExperiment = undefined;
    }
  }

  var eventSeen = window.__umPopupExperimentEventSeen || (window.__umPopupExperimentEventSeen = {});
  function pushDataLayer(eventName, payload, dedupeKey) {
    if (!eventName) return;
    if (dedupeKey && eventSeen[dedupeKey]) return;
    var data = Object.assign({ event: eventName }, payload || {});
    window.dataLayer.push(data);
    if (dedupeKey) eventSeen[dedupeKey] = true;
  }

  function getLifecycleExperimentPayload(context) {
    if (context && context.eligible) {
      return {
        experiment_name: context.name,
        experiment_variant: context.variant,
        popup_eligible_segment: context.segment || 'eligible'
      };
    }
    return {
      popup_eligible_segment: 'ineligible'
    };
  }

  function isPopupExperimentDebugEnabled() {
    try {
      if (window.__umPopupExperimentDebug === true) return true;
      if (window.location && /(?:\?|&)um_popup_debug=1(?:&|$)/.test(window.location.search || '')) return true;
      return localStorage.getItem('um_popup_debug') === '1';
    } catch (e) {
      return window.__umPopupExperimentDebug === true;
    }
  }

  function popupExperimentDebug(stage, detail) {
    if (!isPopupExperimentDebugEnabled()) return;
    var payload = {
      at: new Date().toISOString(),
      stage: stage || 'debug',
      detail: detail || {}
    };
    window.__umPopupExperimentDebugLog = window.__umPopupExperimentDebugLog || [];
    window.__umPopupExperimentDebugLog.push(payload);
    if (window.__umPopupExperimentDebugLog.length > 200) {
      window.__umPopupExperimentDebugLog.shift();
    }
    if (window.console && typeof console.log === 'function') {
      console.log('[UM Popup Experiment]', payload);
    }
  }

  function getFetchDebugUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartDebugRequest(url) {
    return /\/cart(?:\/|\.js|\/update\.js|\/change\.js)/.test(String(url || ''));
  }

  function installPopupExperimentFetchDebugTap() {
    if (!isPopupExperimentDebugEnabled()) return;
    if (window.__umPopupExperimentFetchDebugTapInstalled) return;
    if (typeof window.fetch !== 'function') return;

    var nativeFetch = window.fetch;
    window.__umPopupExperimentFetchDebugTapInstalled = true;

    window.fetch = function (input, init) {
      var method = (init && init.method) ? String(init.method).toUpperCase() : 'GET';
      var url = getFetchDebugUrl(input);
      var isCart = isCartDebugRequest(url);

      if (isCart) {
        popupExperimentDebug('fetch_cart_request', {
          method: method,
          url: url
        });
      }

      return nativeFetch.apply(this, arguments)
        .then(function (response) {
          if (!isCart) return response;

          var status = response ? response.status : 0;
          var cloned = null;
          try {
            cloned = response.clone();
          } catch (e) {
            cloned = null;
          }

          if (!cloned) {
            popupExperimentDebug('fetch_cart_response', {
              method: method,
              url: url,
              status: status
            });
            return response;
          }

          return cloned.json()
            .then(function (payload) {
              var attrs = payload && payload.attributes ? payload.attributes : null;
              popupExperimentDebug('fetch_cart_response', {
                method: method,
                url: url,
                status: status,
                popupAttribute: attrs ? (attrs[CART_ATTRIBUTE_KEY] || '') : '',
                attrKeys: attrs ? Object.keys(attrs) : []
              });
              return response;
            })
            .catch(function () {
              popupExperimentDebug('fetch_cart_response_non_json', {
                method: method,
                url: url,
                status: status
              });
              return response;
            });
        })
        .catch(function (error) {
          if (isCart) {
            popupExperimentDebug('fetch_cart_error', {
              method: method,
              url: url,
              message: error && error.message ? error.message : String(error || '')
            });
          }
          throw error;
        });
    };
  }

  function fetchCartAttributes() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-store'
      }
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('cart_read_failed');
      return response.json();
    }).then(function (cart) {
      if (!cart || typeof cart !== 'object') return {};
      if (!cart.attributes || typeof cart.attributes !== 'object') return {};
      return cart.attributes;
    });
  }

  function updateCartAttribute(key, value) {
    if (!key) return Promise.resolve(null);
    if (window.theme && theme.cart && typeof theme.cart.updateAttribute === 'function') {
      popupExperimentDebug('cart_update_via_theme_api', {
        key: key,
        value: value
      });
      return theme.cart.updateAttribute(key, value);
    }

    popupExperimentDebug('cart_update_via_fetch_fallback', {
      key: key,
      value: value
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: (function () {
          var attrs = {};
          attrs[key] = value;
          return attrs;
        })()
      })
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('cart_update_failed');
      return response.json();
    });
  }

  var popupCartWriteInFlight = false;
  function writePopupExperimentToCart(reason) {
    if (!experimentContext || !experimentContext.eligible || !experimentContext.variant) return;
    if (popupCartWriteInFlight) return;
    popupCartWriteInFlight = true;

    var beforeAttrs = null;
    fetchCartAttributes()
      .then(function (attrs) {
        beforeAttrs = attrs || {};
        popupExperimentDebug('cart_write_before', {
          reason: reason || 'unknown',
          expected: experimentContext.variant,
          existing: beforeAttrs[CART_ATTRIBUTE_KEY] || '',
          keys: Object.keys(beforeAttrs || {})
        });
        return updateCartAttribute(CART_ATTRIBUTE_KEY, experimentContext.variant);
      })
      .then(function (responseCart) {
        var attrs = responseCart && responseCart.attributes ? responseCart.attributes : null;
        popupExperimentDebug('cart_write_response', {
          reason: reason || 'unknown',
          expected: experimentContext.variant,
          responseValue: attrs ? (attrs[CART_ATTRIBUTE_KEY] || '') : '',
          responseKeys: attrs ? Object.keys(attrs) : []
        });
        return fetchCartAttributes().catch(function () {
          return null;
        });
      })
      .then(function (afterAttrs) {
        if (!afterAttrs) return;
        popupExperimentDebug('cart_write_after', {
          reason: reason || 'unknown',
          expected: experimentContext.variant,
          finalValue: afterAttrs[CART_ATTRIBUTE_KEY] || '',
          keys: Object.keys(afterAttrs || {})
        });
      })
      .catch(function (error) {
        popupExperimentDebug('cart_write_error', {
          reason: reason || 'unknown',
          message: error && error.message ? error.message : String(error || '')
        });
      })
      .finally(function () {
        popupCartWriteInFlight = false;
      });
  }

  if (experimentContext.eligible) {
    installPopupExperimentFetchDebugTap();
    writePopupExperimentToCart('init');
    window.__umPopupExperimentDebugApi = {
      forceCartWrite: function (reason) {
        writePopupExperimentToCart(reason || 'manual_force');
      },
      getLog: function () {
        return (window.__umPopupExperimentDebugLog || []).slice();
      }
    };

    if (!window.__umPopupExperimentCartWriteBound) {
      window.__umPopupExperimentCartWriteBound = true;
      document.addEventListener('submit', function (event) {
        var target = event && event.target;
        if (!(target instanceof Element)) return;
        if (!target.matches('form[action*="/cart/add"]')) return;
        window.setTimeout(function () {
          writePopupExperimentToCart('post_add_to_cart_submit');
        }, 700);
      }, true);
    }

    if (!window.__umPopupExperimentCartDebugEventsBound) {
      window.__umPopupExperimentCartDebugEventsBound = true;
      document.addEventListener('um:cart-mode-changed', function (event) {
        popupExperimentDebug('event_cart_mode_changed', {
          detail: event && event.detail ? event.detail : null
        });
      });
      document.addEventListener('cart:build', function () {
        popupExperimentDebug('event_cart_build');
      });
      window.addEventListener('pageshow', function () {
        popupExperimentDebug('event_pageshow');
      });
    }
  }
  */

  // One controller for both offers. Never enqueue an automatic open in _klOnsite.
  var config = Object.assign({
    engagedMobileEnabled: true, sessionForegroundMs: 45000, collectionForegroundMs: 5000,
    pdpForegroundMs: 30000, idleMs: 3000, recoveryMs: 10000, optionCooldownMs: 30000, libraryWaitMs: 30000
  }, window.umKlaviyoTriggerConfig || {});
  var context = window.umKlaviyoPageContext || {};
  var SESSION_KEY = 'um_klaviyo_browsing_v2';
  var SUBSCRIBER_KEY = 'um_klaviyo_submitted';
  var session = readSession();
  var form = null;
  var timer = null;
  var suspended = document.hidden;
  var foregroundStarted = suspended ? null : Date.now();
  var pageForegroundMs = 0;
  var galleryEngaged = false;
  var manualOptions = false;
  var returnEligible = false;
  var lastActivity = Date.now();
  var recoverUntil = Number(session.recoverUntil) || 0;
  var generation = 0;
  var opening = false;
  var requestedOpen = false;
  var openFormId = null;
  var triggerReason = '';
  var lastDecision = '';
  var cartCount = Number(context.cartCount) || 0;
  var overlays = new Set();
  var observedOptions = new WeakSet();
  var observedBrowsing = new WeakSet();
  var visibleBrowsing = new Set();
  var overlayWasOpen = false;
  var pointer = null;
  var previewOpen = false;
  var navigationPending = false;
  var reachedOptions = false;
  var activePointers = new Set();
  var touchCount = 0;
  var formsEngineReady = false;
  var readinessStarted = null;
  var readinessBackoff = 1000;

  function readSession() {
    try { return Object.assign({ foregroundMs: 0, appeared: false, atc: false, drafts: {} }, JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}')); }
    catch (_) { return { foregroundMs: 0, appeared: false, atc: false, drafts: {}, storageUnavailable: true }; }
  }
  function persist() {
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(session)); }
    catch (_) { session.storageUnavailable = true; }
  }
  function localValue(key) { try { return localStorage.getItem(key); } catch (_) { return null; } }
  function elapsed() { return foregroundStarted === null ? 0 : Math.max(0, Date.now() - foregroundStarted); }
  function checkpoint() {
    var delta = elapsed();
    session.foregroundMs += delta;
    pageForegroundMs += delta;
    foregroundStarted = suspended ? null : Date.now();
    persist();
  }
  function enterContext() {
    returnEligible = context.pageType === 'collection' && session.lastPageType === 'product' && session.lastPdpEngaged === true;
    session.lastPageType = context.pageType;
    if (context.pageType === 'product') session.lastPdpEngaged = galleryEngaged;
    persist();
  }
  function allowed(method) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(privacy && typeof privacy[method] === 'function' && privacy[method]()); }
    catch (_) { return false; }
  }
  function log(event, reason, eventFormId) {
    // Existing dataLayer transport, with Shopify's analytics permission applied.
    // Never copy Klaviyo metaData, option values, addresses or entered text.
    if (!allowed('analyticsProcessingAllowed')) return;
    window.dataLayer.push({ event: event, form_id: eventFormId || (form && form.id), page_type: context.pageType,
      device_type: window.matchMedia && window.matchMedia('(min-width: 770px)').matches ? 'desktop' : 'mobile',
      reason: reason || '', trigger_regime: config.engagedMobileEnabled ? 'engaged_mobile_v2' : 'legacy_timer' });
  }
  function decision(reason) {
    if (reason === lastDecision) return;
    lastDecision = reason;
    log(reason === 'eligible' ? 'popup_eligible' : 'popup_suppressed', reason);
  }
  function subscriberExcluded() {
    if (context.subscriber || session.submitted || localValue(SUBSCRIBER_KEY)) return true;
    // Custom triggers override Klaviyo visitor targeting. Conservatively exclude
    // identified profiles as well as Shopify subscribers, without logging identity.
    try {
      var row = document.cookie.split('; ').find(function (part) { return part.indexOf('__kla_id=') === 0; });
      if (!row) return false;
      var raw = decodeURIComponent(row.slice(9));
      var identity;
      try { identity = JSON.parse(atob(raw)); } catch (_) { identity = JSON.parse(raw); }
      return !!(identity.$email || identity.email || identity.$exchange_id);
    } catch (_) { return false; }
  }
  var draftSelector = '[data-io-personalisation-part], .personalised_map_age textarea, ' +
    '.io-pop-art-dep-words textarea, .io-pop-art-dep-words input, [data-io-pop-art-property="Pop art text"], ' +
    '#infiniteoptions-container input[type="text"], textarea[name^="properties["], #map-canvas-id, [data-map-out="refined"]';
  function currentDraft() {
    return Array.from(document.querySelectorAll(draftSelector)).some(function (node) {
      return node.matches('[data-map-out="refined"]') ? node.value === '1' : !!String(node.value || '').trim();
    });
  }
  function updateDraft() {
    if (context.pageType !== 'product') return;
    session.drafts[String(context.productId)] = currentDraft();
    persist();
  }
  function hasDraft() {
    if (session.editorStarted || currentDraft() || Object.keys(session.drafts).some(function (id) { return session.drafts[id]; })) return true;
    try {
      // This is the theme's existing saved-map key, not a new draft store.
      for (var i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).indexOf('um-map-design-saved:') === 0) return true;
      }
    } catch (_) {}
    return false;
  }
  function visible(node) {
    if (!node || !node.isConnected || node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
    if (node.tagName === 'DIALOG' && !node.open) return false;
    var style = window.getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && node.getClientRects().length > 0;
  }
  var overlaySelector = 'dialog, [role="dialog"], [aria-modal="true"], .modal, .pswp, ' +
    '.map-modal-overlay, .contact-advice-panel__layer, .sticky-add-to-cart__help-popover, ' +
    '#shopify-pc__banner, #shopify-pc__prefs, #hubspot-messages-iframe-container';
  function overlayOpen() {
    var classes = document.documentElement.classList;
    var bodyClasses = document.body.classList;
    if (previewOpen || openFormId || window.activePhotoswipeGallery || classes.contains('js-drawer-open') || classes.contains('js-drawer-closing') ||
      classes.contains('lock-scroll') || classes.contains('contact-advice-panel-open') ||
      classes.contains('um-hs-help-widget-open') || classes.contains('hs-messages-widget-open') ||
      bodyClasses.contains('modal-open') || bodyClasses.contains('video-modal-open')) return true;
    return Array.from(overlays).some(function (node) {
      if (!node.isConnected) { overlays.delete(node); return false; }
      if (node.id === 'hubspot-messages-iframe-container') return false; // Closed bubble remains visible; use HubSpot open classes above.
      if (node.classList.contains('pswp') && !node.classList.contains('pswp--open')) return false;
      return visible(node);
    });
  }
  function syncOverlay() {
    var isOpen = overlayOpen();
    if (isOpen !== overlayWasOpen) {
      overlayWasOpen = isOpen;
      if (!isOpen) { recoverUntil = Date.now() + config.recoveryMs; session.recoverUntil = recoverUntil; persist(); }
      invalidate();
    }
  }
  function blocker() {
    if (!form) return 'no_form';
    if (window.__PDP_PSEUDO_SALE_SUPPRESS_KLAVIYO__ === true) return 'sale_suppression';
    if (window.matchMedia && window.matchMedia('(min-width: 770px)').matches) return 'desktop';
    if (suspended || document.hidden) return 'background';
    if (navigationPending) return 'navigation';
    if (activePointers.size || touchCount) return 'touch_in_progress';
    if (session.storageUnavailable) return 'session_storage_unavailable';
    if (session.appeared || requestedOpen) return 'session_limit';
    if (session.atc) return 'atc_attempt';
    if (subscriberExcluded()) return 'subscriber';
    if (Date.now() < Number(localValue('klaviyo_form_suppress_until_' + form.id) || 0)) return 'dismissal_cooldown';
    if (!allowed('marketingAllowed')) return 'consent';
    if (cartCount > 0) return 'nonempty_cart';
    if (hasDraft()) return 'personalisation_draft';
    if (document.activeElement && document.activeElement.matches('input, textarea, select, [contenteditable="true"], [role="textbox"]')) return 'form_input';
    if (overlayOpen()) return 'overlay';
    if (config.engagedMobileEnabled && session.optionCooldownUntil > session.foregroundMs + elapsed()) return 'option_cooldown';
    if (context.pageType === 'product' && manualOptions && config.engagedMobileEnabled) return 'manual_options';
    return '';
  }
  function opportunity() {
    if (!config.engagedMobileEnabled) return { reason: 'legacy_timer', wait: Math.max(0, form.delay - pageForegroundMs - elapsed()) };
    if (context.pageType === 'product' && galleryEngaged && Array.from(visibleBrowsing).some(visible)) {
      return { reason: 'pdp_browsing_pause', wait: Math.max(0, config.pdpForegroundMs - pageForegroundMs - elapsed()) };
    }
    if (context.pageType === 'collection' && returnEligible) {
      return { reason: 'return_to_browsing', wait: Math.max(0, config.sessionForegroundMs - session.foregroundMs - elapsed(), config.collectionForegroundMs - pageForegroundMs - elapsed()) };
    }
    return null;
  }
  function cancelTimer() { if (timer !== null) clearTimeout(timer); timer = null; }
  function schedule(delay) {
    cancelTimer();
    if (!suspended) timer = setTimeout(evaluate, Math.max(1, delay));
  }
  function invalidate() {
    generation++;
    cancelTimer();
    if (!suspended) schedule(0);
  }
  function activity() {
    lastActivity = Date.now();
    generation++; // Cancels any in-flight cart recheck. No DOM reads on scroll/touchmove.
    if (timer === null && !suspended && !session.appeared && !session.atc) schedule(config.idleMs);
  }
  function libraryReady() {
    // The onsite API installs a queuing stub before the forms engine starts.
    // Wait for an engine state event AND the custom-trigger listener request.
    var listeners = window.__klaviyoRequestedEventListeners;
    return formsEngineReady && Array.isArray(listeners) && listeners.indexOf('JS_CUSTOM_TRIGGER') !== -1 &&
      !!(window._klOnsite && typeof window._klOnsite.openForm === 'function');
  }
  function evaluate() {
    timer = null;
    syncOverlay();
    var reason = blocker();
    if (reason) { decision(reason); return; }
    var candidate = opportunity();
    if (!candidate) { decision('no_opportunity'); return; }
    var wait = Math.max(candidate.wait, lastActivity + config.idleMs - Date.now(), recoverUntil - Date.now());
    if (wait > 0) { decision(candidate.wait > 0 ? 'foreground_threshold' : 'quiet_period'); schedule(wait); return; }
    // Do not call the onsite queuing stub before the forms engine is ready.
    if (!libraryReady()) {
      decision('library_not_ready');
      if (readinessStarted === null) readinessStarted = Date.now();
      if (Date.now() - readinessStarted < config.libraryWaitMs) {
        schedule(readinessBackoff);
        readinessBackoff = Math.min(8000, readinessBackoff * 2);
      }
      return;
    }
    decision('eligible');
    if (opening) return;
    opening = true;
    var epoch = generation;
    // Fresh cart state at the opportunity, rather than continuously polling /cart.js.
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_unavailable');
      return response.json();
    }).then(function (cart) {
      cartCount = Number(cart.item_count);
      if (!Number.isFinite(cartCount)) throw new Error('cart_unavailable');
      if (epoch !== generation) { return; }
      // Recheck every condition after the asynchronous read; never queue an open.
      syncOverlay();
      var denied = blocker();
      var latest = opportunity();
      if (denied || !latest || latest.wait > 0 || Date.now() < recoverUntil || Date.now() - lastActivity < config.idleMs ||
        !libraryReady()) {
        decision(denied || 'context_changed'); return;
      }
      requestedOpen = true;
      session.appeared = true; // Reserve the shared budget before either form can open.
      persist();
      triggerReason = latest.reason;
      log('popup_trigger', triggerReason);
      // The installed SDK compares this argument with a string form ID.
      window._klOnsite.openForm(form.id);
    }).catch(function () { decision('cart_or_open_unavailable'); })
      .finally(function () {
        opening = false;
        if (epoch !== generation && !suspended && !navigationPending && !session.appeared && timer === null) schedule(config.idleMs);
      });
  }
  var simpleOptionSelector = '.variant-wrapper, .variant-input-wrap, [data-featured-size-key], .um-featured-size, .pdp-featured-size, ' +
    '.option_colour_tone, [data-pdp-aged-tone-proxy], .option_frame_colour_new, .option_custom_frame_colour_new, ' +
    '.option_frame_colour_canvas, .option_hanger_colour, .option_map_version, .option_version, ' +
    '[name="properties[Map version]" i], [data-finish-input-id]';
  var optionSelector = simpleOptionSelector + ', .io-more-personalisation-item, ' +
    '[data-pdp-pricing-finish-first-finish-section], #infiniteoptions-container, [data-io-more-personalisation-toggle]';
  var atcSelector = '#standardATCbutton, [data-add-to-cart], .add-to-cart, [js-product="stickyAddToCart"] button[type="submit"], .sticky-add-to-cart__button';
  function markEngaged() {
    if (context.pageType !== 'product') return;
    session.lastPdpEngaged = true;
    checkpoint();
  }
  function optionInteraction(target) {
    var choiceLabel = target.closest('label');
    var simpleChoice = target.closest(simpleOptionSelector) ||
      (choiceLabel && choiceLabel.querySelector('[name="properties[Map version]" i]'));
    if (simpleChoice) {
      markEngaged();
      // Use the shared foreground clock so hidden time does not age the cooldown.
      // No expiry timer: only a subsequent browsing opportunity can reconsider it.
      session.optionCooldownUntil = session.foregroundMs + config.optionCooldownMs;
      persist();
    } else {
      manualOptions = true;
      markEngaged();
    }
    invalidate();
  }
  function galleryInteraction() { galleryEngaged = true; markEngaged(); invalidate(); }
  function atcAttempt() { session.atc = true; persist(); invalidate(); }
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !event.target.closest) return;
    activity();
    if (event.target.closest(atcSelector)) { atcAttempt(); return; }
    var anchor = event.target.closest('a[href]');
    if (anchor && anchor.pathname !== location.pathname && anchor.target !== '_blank' && !anchor.hasAttribute('download')) {
      navigationPending = true; invalidate();
      // Theme filtering may prevent a link's default navigation after capture.
      setTimeout(function () { if (event.defaultPrevented) { navigationPending = false; invalidate(); } }, 0);
    }
    if (context.pageType !== 'product') return;
    if (event.target.closest('.map-open-btn')) { session.editorStarted = true; persist(); }
    if (event.target.closest(optionSelector)) optionInteraction(event.target);
    if (event.target.closest('[data-product-thumb]') ||
      (event.target.closest('.product__photos, [data-product-images], .product-slideshow') &&
        event.target.closest('.js-photoswipe__zoom, .product__photo-zoom, .flickity-prev-next-button'))) galleryInteraction();
  }, true);
  document.addEventListener('change', function (event) {
    if (event.isTrusted && context.pageType === 'product' && event.target.closest(optionSelector)) {
      activity(); optionInteraction(event.target);
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[action*="/cart/add"]')) atcAttempt();
  }, true);
  document.addEventListener('input', function (event) {
    if (event.isTrusted) { updateDraft(); activity(); invalidate(); }
  }, true);
  document.addEventListener('focusin', invalidate);
  document.addEventListener('focusout', function () { activity(); invalidate(); });
  window.addEventListener('scroll', activity, { passive: true });
  // Components stop touchend propagation (for example the add-on cards).
  // Capture touch lifecycle at window so a completed gesture cannot leave the
  // shared guard stuck in touch_in_progress. No layout work in these handlers.
  window.addEventListener('touchstart', function (event) { touchCount = event.touches ? event.touches.length : 1; activity(); }, { passive: true, capture: true });
  window.addEventListener('touchmove', activity, { passive: true, capture: true });
  window.addEventListener('touchend', function (event) { touchCount = event.touches ? event.touches.length : 0; activity(); }, { passive: true, capture: true });
  window.addEventListener('touchcancel', function () { touchCount = 0; activity(); }, { passive: true, capture: true });
  document.addEventListener('pointerdown', function (event) {
    if (!event.isTrusted) return;
    activePointers.add(event.pointerId);
    activity();
    if (context.pageType === 'product' && event.target.closest('.product-slideshow')) {
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
    }
  }, { passive: true, capture: true });
  window.addEventListener('pointerup', function (event) {
    activePointers.delete(event.pointerId);
    activity();
    if (event.isTrusted && pointer && event.pointerId === pointer.id &&
      Math.abs(event.clientX - pointer.x) >= 25 && Math.abs(event.clientX - pointer.x) > Math.abs(event.clientY - pointer.y) * 1.5) galleryInteraction();
    pointer = null;
  }, { passive: true, capture: true });
  window.addEventListener('pointercancel', function (event) { activePointers.delete(event.pointerId); pointer = null; activity(); }, { passive: true, capture: true });
  document.addEventListener('keydown', function (event) { if (event.isTrusted) activity(); }, true);

  var reachObserver = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    if (reachedOptions || !entries.some(function (entry) { return entry.isIntersecting; })) return;
    reachedOptions = true;
    markEngaged();
  }, { threshold: 0.1 }) : null;
  var browsingSelector = '[data-pdp-main-price], .product-block--price, .product-single__title, .pdp-short-description, .custom-city-map-intro';
  var browsingObserver = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) visibleBrowsing.add(entry.target);
      else visibleBrowsing.delete(entry.target);
    });
    invalidate();
  }, { threshold: 0.1 }) : null;
  var reachSelector = '.variant-wrapper[data-handle="finish"], [data-pdp-featured-sizes], .um-featured-sizes-card, #infiniteoptions-container';
  var stateObserver = new MutationObserver(function () { syncOverlay(); });
  function discover(root) {
    if (!root || !root.querySelectorAll || (window.matchMedia && window.matchMedia('(min-width: 770px)').matches)) return;
    var hasChildren = root.childElementCount !== 0;
    var discoveredOverlay = false;
    var nodes = hasChildren ? Array.from(root.querySelectorAll(overlaySelector)) : [];
    if (root.matches && root.matches(overlaySelector)) nodes.push(root);
    nodes.forEach(function (node) {
      if (overlays.has(node)) return;
      discoveredOverlay = true;
      overlays.add(node);
      stateObserver.observe(node, { attributes: true, attributeFilter: ['class', 'hidden', 'style', 'open', 'aria-hidden'] });
    });
    if (reachObserver && context.pageType === 'product') {
      var targets = hasChildren ? Array.from(root.querySelectorAll(reachSelector)) : [];
      if (root.matches && root.matches(reachSelector)) targets.push(root);
      targets.forEach(function (node) { if (!observedOptions.has(node)) { observedOptions.add(node); reachObserver.observe(node); } });
    }
    if (browsingObserver && context.pageType === 'product') {
      var browsing = hasChildren ? Array.from(root.querySelectorAll(browsingSelector)) : [];
      if (root.matches && root.matches(browsingSelector)) browsing.push(root);
      browsing.forEach(function (node) { if (!observedBrowsing.has(node)) { observedBrowsing.add(node); browsingObserver.observe(node); } });
    }
    return discoveredOverlay;
  }
  discover(document.body);
  stateObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  // Only discover added components; no subtree attribute/text observation and no
  // DOM scans on translation/price changes or each scroll frame.
  new MutationObserver(function (records) {
    var overlaysChanged = false;
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) { if (node.nodeType === 1 && discover(node)) overlaysChanged = true; });
    });
    if (overlaysChanged || Array.from(overlays).some(function (node) { return !node.isConnected; })) syncOverlay();
  }).observe(document.body, { childList: true, subtree: true });
  ['drawerOpen', 'modalOpen', 'photoswipe:open', 'photoswipe:close', 'contact-advice-panel:open'].forEach(function (name) {
    document.addEventListener(name, function () { syncOverlay(); invalidate(); });
  });
  ['cart:updated', 'cart:build', 'ajaxProduct:added', 'um:nested-atc-result'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (name === 'ajaxProduct:added' || name === 'um:nested-atc-result') atcAttempt();
      var cart = event.detail && event.detail.cart;
      if (cart && Number.isFinite(Number(cart.item_count))) cartCount = Number(cart.item_count);
      invalidate();
    });
  });
  document.addEventListener('um:sticky-preview-state', function (event) {
    previewOpen = !!(event.detail && event.detail.open); syncOverlay(); invalidate();
  });
  ['pdp:pop-art-draft-change', 'pdp:addon-approval-change'].forEach(function (name) {
    document.addEventListener(name, function () { updateDraft(); invalidate(); });
  });
  window.addEventListener('message', function (event) {
    var frame = document.getElementById('map-poster-frame');
    if (!frame || event.source !== frame.contentWindow || !event.data) return;
    try { if (event.origin !== new URL(frame.src, location.href).origin) return; } catch (_) { return; }
    if (event.data.type === 'MAP_APP_SAVED' || (event.data.type === 'MAP_APP_STATE' && event.data.savedCanvasId)) {
      session.drafts[String(context.productId)] = true; persist(); invalidate();
    }
  });
  window.addEventListener('storage', function () { session = readSession(); invalidate(); });
  document.addEventListener('visibilitychange', function () {
    checkpoint();
    suspended = document.hidden;
    foregroundStarted = suspended ? null : Date.now();
    activePointers.clear(); touchCount = 0; pointer = null;
    if (!suspended) { recoverUntil = Date.now() + config.recoveryMs; session.recoverUntil = recoverUntil; persist(); lastActivity = Date.now(); }
    invalidate();
  });
  window.addEventListener('pagehide', function () {
    updateDraft(); checkpoint(); suspended = true; foregroundStarted = null; generation++; cancelTimer();
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    session = readSession(); suspended = document.hidden; foregroundStarted = suspended ? null : Date.now();
    pageForegroundMs = 0; galleryEngaged = false; manualOptions = false; reachedOptions = false; navigationPending = false;
    visibleBrowsing.clear();
    if (browsingObserver) { browsingObserver.disconnect(); observedBrowsing = new WeakSet(); discover(document.body); }
    enterContext(); recoverUntil = Date.now() + config.recoveryMs; session.recoverUntil = recoverUntil; persist(); lastActivity = Date.now(); invalidate();
  });
  window.addEventListener('popstate', function () { navigationPending = true; generation++; cancelTimer(); });
  document.addEventListener('visitorConsentCollected', function () { lastDecision = ''; invalidate(); });
  document.addEventListener('load', function (event) {
    if (event.target.tagName === 'SCRIPT') { readinessStarted = null; readinessBackoff = 1000; invalidate(); }
  }, true);
  window.addEventListener('triggering-state-update', function () {
    if (formsEngineReady) return;
    formsEngineReady = true;
    readinessStarted = null; readinessBackoff = 1000;
    invalidate();
  });
  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    var id = String(detail.formId || detail.formID || '');
    var type = String(detail.type || '').toLowerCase();
    if (type === 'open') {
      openFormId = id;
      session.appeared = true; persist();
      if (id === 'UbGbjg' || id === 'Vzb3rr') {
        log('klaviyo_form_open', requestedOpen && form && form.id === id ? triggerReason : 'voluntary', id);
      }
    }
    if (type === 'close' || type === 'submit') {
      if (openFormId === id) openFormId = null;
      if (id === 'UbGbjg' || id === 'Vzb3rr') {
        try { localStorage.setItem('klaviyo_form_suppress_until_' + id, String(Date.now() + (form && form.id === id ? form.cooldown : 5 * 864e5))); } catch (_) {}
        if (type === 'submit') {
          session.submitted = true;
          try { localStorage.setItem(SUBSCRIBER_KEY, '1'); } catch (_) {}
        }
        log(type === 'close' ? 'klaviyo_form_close' : 'klaviyo_form_submit', requestedOpen && form && form.id === id ? triggerReason : 'voluntary', id);
      }
    }
    syncOverlay(); invalidate();
  });
  var mediaQuery = window.matchMedia && window.matchMedia('(min-width: 770px)');
  if (mediaQuery) {
    function viewportChanged() { discover(document.body); invalidate(); }
    if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', viewportChanged);
    else if (mediaQuery.addListener) mediaQuery.addListener(viewportChanged);
  }
  window.initKlaviyoDelayedForm = function (formId, delayMs, suppressMs) {
    if (!formId || (form && form.id === formId)) return;
    form = { id: formId, delay: Math.max(10000, Number(delayMs) || 0), cooldown: Number(suppressMs) || 5 * 864e5 };
    invalidate();
  };
  enterContext();
  // Use the store's existing privacy state. Load Shopify's small API once if the
  // app has not loaded it yet; no consent grants or banner settings are changed.
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { invalidate(); });
  }

  if (Array.isArray(window._umKlaviyoInitQueue) && window._umKlaviyoInitQueue.length) {
    window._umKlaviyoInitQueue.forEach(function (args) {
      if (!Array.isArray(args) || !args.length) return;
      window.initKlaviyoDelayedForm.apply(window, args);
    });
    window._umKlaviyoInitQueue = [];
  }
})();
